import { useEffect, useRef } from "react";
import "./Animation.css";

const SPLASH_DURATION = 3000;

export function SplashScreen({ logo, onFinish }) {
  const finishRef = useRef(onFinish);
  finishRef.current = onFinish;

  useEffect(() => {
    const timer = setTimeout(() => finishRef.current(), SPLASH_DURATION);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="vasro-splash"
      role="status"
      aria-label="Loading Vasro Ventures"
    >
      <span className="splash-orb splash-orb-one" />
      <span className="splash-orb splash-orb-two" />

      <div className="splash-content">
        <div className="splash-logo-wrap">
          <span className="splash-ring" />
          <img className="splash-logo" src={logo} alt="Vasro Ventures" />
        </div>
        <p className="splash-tag">Admin Panel</p>
        <div className="splash-progress">
          <span />
        </div>
      </div>
    </div>
  );
}
